import DecimalService from '../decimalService';

const sumMultipleNumbersAsDecimals = (numbers: number[]) => {
    if (numbers.length === 0) return 0;
    if (numbers.length === 1) return numbers[0];

    const [head, ...rest] = numbers.map((number) => DecimalService.parse(number));
    return DecimalService.toNumber(rest.reduce((acc, current) => DecimalService.sum(acc, current), head));
};
export default sumMultipleNumbersAsDecimals;
